import React from 'react'

function StarReview({
    value = 0,
    onChange,
    maxStars = 5,
    className = ""
}) {
    return (
        <div className={`close_oppor_rating_input ${className}`}>
            {[...Array(maxStars)].map((_, index) => {
                const star = index + 1;

                return (
                    <button
                        key={star}
                        type="button"
                        className={`close_oppor_star ${
                            star <= value ? "active" : ""
                        }`}
                        onClick={() => onChange(star)}
                        aria-label={`Rate ${star} star${star > 1 ? "s" : ""}`}
                    >
                        ★
                    </button>
                );
            })}
        </div>
    );
}

export default StarReview